module.exports = __webpack_public_path__ + "img/blebox_logo.c1053829.svg";